/**
 * main.tsx - Application Entry Point
 *
 * Initializes the React application and mounts it to DOM elements.
 */

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { applyFontExperiment } from './utilities/fontExperiment'

// Before the first render, so the Arabic font/size experiment doesn't flash.
applyFontExperiment()

const widgetDivs = document.querySelectorAll('.cair-widget');

widgetDivs.forEach(div => {
    createRoot(div).render(
        <StrictMode>
            <App />
        </StrictMode>,
    )
});
